// front/src/api/cotations.js
import { apiFetch } from '../utils/apiFetch';
import { mklog } from '../utils/debug';
const log = mklog('SHEET');

export function normalizeCodes(s) {
  return String(s || '')
    .toUpperCase()
    .replace(/["'\s]/g, '')
    .replace(/\++/g, '+')
    .replace(/^\+|\+$/g, '');
}

// front/src/api/cotations.js (ou un utils/shared)
export function normalizeSheetPayload(data) {
  if (!data) return null;
  const raw = data?.raw ?? data;
  const table = Array.isArray(raw?.table) ? raw.table : [];
  const updatedAt = raw?.updatedAt ?? data?.updatedAt ?? null;
  // garder les autres champs utiles si présents (banner, version, etc.)
  return {
    table,
    updatedAt,
    banner: data?.banner ?? raw.message ?? raw.text ?? null,
    version: data?.version ?? raw.version ?? null,
    raw: data?.raw ?? data,
  };
}

export // Domaine machine (pour l’API)
function domainOf(p) {
  const raw = (p?.domaine || p?.cotationDomaine || p?.cotation_json?.domaine || '')
    .toString()
    .toUpperCase();
  return raw.startsWith('TRAUMA') ? 'traumato' : 'medecine';
}

/**
 * LANCE la synchro Google Sheet côté back (traumato) et renvoie l'état courant.
 * On ne lit PAS le body du POST (certains wrappers l'ont déjà consommé).
 * On fait systématiquement un GET ensuite pour récupérer l'instantané.
 */
export async function sheetGet(passageId, token) {
  log('GET sheet', { passageId });
  const r = await apiFetch(`/api/cotation/passages/${passageId}/cotation/sheet`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const data = await (r.json?.() ?? r);
  log('GET sheet -> ok', {
    rows: Array.isArray(data?.raw?.table) ? data.raw.table.length : data?.table?.length || 0,
    updatedAt: data?.updatedAt || data?.raw?.updatedAt || null,
  });
  return normalizeSheetPayload(data);
}

export async function sheetSyncAndPoll({
  passageId,
  codes,
  token,
  domain = 'traumato',
  musiqId,
  isDemo,
  resQualif,
}) {
  const normalized = normalizeCodes(codes);
  log('POST resync', { passageId, codes: normalized, resQualif });
  const res = await apiFetch(`/api/cotation/passages/${passageId}/cotation/sheet/resync`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ codes, domain, musiqId, isDemo, resQualif }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  // On ignore le body du POST et on lit l’état via GET
  return sheetGet(passageId, token, domain);
}

export async function getAllActes() {
  const res = await apiFetch('/api/cotation/all-actes', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger la configuration');
  return res.json();
}